<template style="height: 100%;">
  <div class="Useraddsingle">
    <h2>{{ $t('original.New_users') }}</h2>

    <div class="basic">
      <div class="tit">
        <span></span>
        <p>{{ $t('original.Basic_Information') }}</p>
      </div>
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">

        <el-form-item :label="$t('original.account')" prop="UserID">
          <el-input v-model="ruleForm.UserID" :placeholder="$t('original.languages3')"></el-input>
        </el-form-item>
        <el-form-item :label="$t('original.name')" prop="RealName">
          <el-input v-model="ruleForm.RealName" :placeholder="$t('original.languages3')"></el-input>
        </el-form-item>

        
        <el-form-item :label="$t('original.user_types')" prop="RoleIDs">
          <el-select v-model="ruleForm.RoleIDs" :placeholder="$t('original.languages3')" multiple>
            <el-option-group v-for="group in opt" :key="group.key" :label="group.value">
              <el-option v-for="item in group.RoleList" :key="item.key" :label="item.value" :value="item.key">
              </el-option>
            </el-option-group>
          </el-select>
        </el-form-item>


        <el-form-item :label="$t('original.Name_of_Company')" prop="DeptID">
          <div class="block">
            <el-cascader ref="wcascader" @change="Selected_to_shut_dow" @expand-change="bumen" :options="data"
              :props="{ checkStrictly: true }" clearable :placeholder="$t('original.languages3')"></el-cascader>
          </div>
        </el-form-item>

        <el-form-item :label="$t('original.Name_of_Company2')" prop="DeptID">
          <div class="block">
            <el-cascader ref="wcascader2" @change="Selected_to_shut_dow2" @expand-change="bumen" :options="data2"
              :props="{ checkStrictly: true }" clearable :placeholder="$t('original.languages3')"></el-cascader>
          </div>
        </el-form-item>

        <el-form-item :label="$t('original.Name_of_Company3')" prop="DeptID">
          <div class="block">
            <el-cascader ref="wcascader3" @change="Selected_to_shut_dow3" @expand-change="bumen" :options="data3"
              :props="{ checkStrictly: true }" clearable :placeholder="$t('original.languages3')"></el-cascader>
          </div>
        </el-form-item>

        <el-form-item :label="$t('original.grade')" prop="EntryDate">
          <el-select v-model="ruleForm.EntryDate" :placeholder="$t('original.languages3')">
            <el-option v-for="item in gradedata" :key="item.dicKey" :label="item" :value="item">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item :label="$t('original.gender')" prop="Sex">
          <el-radio v-model="ruleForm.Sex" label="1">{{ $t('original.languages5') }}</el-radio>
          <el-radio v-model="ruleForm.Sex" label="0">{{ $t('original.languages6') }}</el-radio>
        </el-form-item>

        <el-form-item :label="$t('original.Date_of_birth')" prop="Birthday">
          <el-date-picker type="date" :placeholder="$t('original.languages3')" value-format="yyyy-MM-dd"
            v-model="ruleForm.Birthday" :picker-options="pickerOptions"></el-date-picker>
        </el-form-item>

        <el-form-item :label="$t('original.phone')" prop="Phone">
          <el-input v-model="ruleForm.Phone" :placeholder="$t('original.languages4')"></el-input>
        </el-form-item>

        <el-form-item :label="$t('original.languages532')" prop="Email">
          <el-input v-model="ruleForm.Email" :placeholder="$t('original.languages532')"></el-input>
        </el-form-item>

        <el-form-item :label="$t('original.Id_number')" prop="IDCard">
          <el-input v-model="ruleForm.IDCard" :placeholder="$t('original.languages4')"></el-input>
        </el-form-item>

        <el-form-item label="户口类型" prop="AccountType">
          <el-radio v-model="ruleForm.AccountType" label="1">{{ $t('original.languages7') }}</el-radio>
          <el-radio v-model="ruleForm.AccountType" label="2">{{ $t('original.languages8') }}</el-radio>
        </el-form-item>



        <!-- <div class="tit">
          <span></span>
          <p>{{ $t('original.Case_information') }}</p>
        </div>

        <el-form-item :label="$t('original.Clinic_type')" prop="ClinicType">
          <el-select v-model="ruleForm.ClinicType" :placeholder="$t('original.languages3')">
            <el-option v-for="item in value6" :key="item.DicKey" :label="item.CDicValue" :value="item.DicKey">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item :label="$t('original.Clinic_date')" prop="ClinicDate">
          <el-date-picker v-model="ruleForm.ClinicDate" type="date" value-format="yyyy-MM-dd"
            :picker-options="pickerOptions" :placeholder="$t('original.languages3')"></el-date-picker>
        </el-form-item>
        <el-form-item :label="$t('original.Cases_of_content')" prop="CaseContent">
          <el-input type="textarea" v-model="ruleForm.CaseContent" maxlength="500" :placeholder="$t('original.languages4')" show-word-limit></el-input>
        </el-form-item>
        <el-form-item :label="$t('original.note')" prop="CaseRemark">
          <el-input v-model="ruleForm.CaseRemark" :placeholder="$t('original.languages4')"></el-input>
        </el-form-item> -->
        <div class="tit">
          <span></span>
          <p>{{ $t('original.languages9') }}</p>
        </div>


        <el-form-item :label="$t('original.languages10')" prop="TheGuardian">
          <el-input :placeholder="$t('original.languages4')" type="textarea" :rows="2" maxlength="500" show-word-limit
            v-model="ruleForm.IndividualResume">
          </el-input>
        </el-form-item>

        <el-form-item label="婚姻状态">
          <el-select v-model="ruleForm.MarriageState" :placeholder="$t('original.languages3')">
            <el-option v-for="item in value7" :key="item.dicKey" :label="item.cDicValue" :value="item.dicKey">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="视频号" >
          <el-input type="text" v-model="ruleForm.VideoAccount" :placeholder="$t('original.languages4')"></el-input>
        </el-form-item>



        <el-form-item :label="$t('original.Admission_time')" prop="TheEntranceDate">
          <el-date-picker value-format="yyyy-MM-dd" :picker-options="pickerOptions" v-model="ruleForm.TheEntranceDate"
            type="date" :placeholder="$t('original.languages3')"></el-date-picker>
        </el-form-item>

        <el-form-item :label="$t('original.The_guardian')" prop="TheGuardian">
          <el-input v-model="ruleForm.TheGuardian" :placeholder="$t('original.languages4')"></el-input>
        </el-form-item>

        <el-form-item :label="$t('original.Guardian_telephone')" prop="TheGuardianPhone">
          <el-input v-model="ruleForm.TheGuardianPhone" :placeholder="$t('original.languages4')"></el-input>
        </el-form-item>

        <el-form-item :label="$t('original.Native_place')" prop="NativePlace">
          <el-select v-model="ruleForm.NativePlace" :placeholder="$t('original.languages3')">
            <el-option v-for="item in value24" :key="item.dicKey" :label="item.cDicValue" :value="item.dicKey">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item :label="$t('original.national')" prop="Nation">
          <el-select v-model="ruleForm.Nation" :placeholder="$t('original.languages3')">
            <el-option v-for="item in value22" :key="item.dicKey" :label="item.cDicValue" :value="item.dicKey">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item :label="$t('original.note')" prop="SchoolRemark">
          <el-input v-model="ruleForm.SchoolRemark" :placeholder="$t('original.languages4')"></el-input>
        </el-form-item>

        <el-form-item :label="$t('original.The_serial_number')" prop="LineNumber">
          <el-input v-model="ruleForm.LineNumber" :placeholder="$t('original.languages4')"></el-input>
        </el-form-item>

        <!-- <MyBread @func="getMsgFormSon"></MyBread> -->
        <el-form-item>
          <el-button type="primary" @click="submitForm('ruleForm')">
            {{ $t('original.Immediately_create') }}
          </el-button>
          <el-button @click="resetForm('ruleForm')">{{$t('original.reset')}} </el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      msgFormSon: 'this is msg',
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now() - 3600 * 1000 * 24 + 8.64e7
        },
      },
      value: '',

      value: [],
      value22: [],
      value24: [],
      value6: [],
      value7: [],
      gradedata: [],
      ruleForm: {
        MarriageState: '',
        IndividualResume: '',
        VideoAccount: '',
        RealName: '',
        LineNumber: '',
        RoleIDs: '',
        UserID: '',
        Sex: '1',
        Birthday: '',
        DeptID: '',
        TrainID: '',
        TeachID: '',
        Phone: '',
        IDCard: '',
        AccountType: '1',
        CaseContent: '',
        ClinicDate: '',
        ClinicType: '',
        CaseRemark: '',
        Class: '',
        TheEntranceDate: '',
        TheGuardian: '',
        NativePlace: '',
        SchoolRemark: '',
        Nation: '',
        TheGuardianPhone: '',
        EntryDate: '',
        CaseRemark: '',
        Email: '',
      },
      opt: '',
      values: '',
      rules: {
        Phone: [{ required: true, message: this.$t('original.languages12'), trigger: 'blur' }],
        Email: [{ required: true, message: "请输入邮箱!", trigger: 'blur' }],
        IDCard: [{ required: true, message: this.$t('original.languages13'), trigger: 'blur' }],
        RealName: [{ required: true, message: this.$t('original.languages14'), trigger: 'blur' }],
        RoleIDs: [{ required: true, message: this.$t('original.languages15'), trigger: 'blur' }],
        DeptID: [{ required: true, message: this.$t('original.languages16'), trigger: 'blur' }],
        TrainID: [{ required: true, message: this.$t('original.languages16z1'), trigger: 'blur' }],
        TeachID: [{ required: true, message: this.$t('original.languages16z2'), trigger: 'blur' }],
        UserID: [{ required: true, message: this.$t('original.languages17'), trigger: 'blur' }],
        Sex: [{ required: true, message: this.$t('original.languages18'), trigger: 'blur' }],
        Birthday: [{ required: true, message: this.$t('original.languages19'), trigger: 'blur' }],
        AccountType: [{ required: true, message: this.$t('original.languages20'), trigger: 'blur' }],
        EntryDate: [{ required: true, message: this.$t('original.languages21'), trigger: 'blur' }]
      },
      data: [],
      data2: [],
      data3: [],
      option: [],
    }
  },
  methods: {
    Selected_to_shut_dow(dt) {
      this.ruleForm.DeptID = dt[dt.length - 1];
      this.$refs.wcascader.dropDownVisible = false;
    },
    Selected_to_shut_dow2(dt) {
      this.ruleForm.TrainID = dt[dt.length - 1];
      this.$refs.wcascader2.dropDownVisible = false;
    },
    Selected_to_shut_dow3(dt) {
      this.ruleForm.TeachID = dt[dt.length - 1];
      this.$refs.wcascader3.dropDownVisible = false;
    },
    getMsgFormSon(data) {
      this.msgFormSon = data;
    },
    submitForm(formName) {
      if (this.msgFormSon == 'this is msg') {
        //判断是否选择
      } else {
        if (this.msgFormSon.dropListInfo.length > 0) {
          var csi = this.msgFormSon.dropListInfo
          var lkokjcid = this.ruleForm
          for (var i = 0; i < csi.length; i++) {
            lkokjcid[csi[i].Control] = csi[i].values
          }
          this.ruleForm = lkokjcid
        }
        if (this.msgFormSon.textBoxInfo.length > 0) {
          var cs2i = this.msgFormSon.textBoxInfo
          var lkokjecid = this.ruleForm
          for (var i = 0; i < cs2i.length; i++) {
            lkokjecid[cs2i[i].Control] = cs2i[i].ControlValue
          }
          this.ruleForm = lkokjecid
        }
      }
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$Http_Post('User/AddUser', this.ruleForm).then((res) => {
              if (res.Code == 200 || res.Code == 0) {
                this.nav_list = res.Data
                this.Global.request_successful(res.Message)
                setTimeout(function () {
                  window.history.back(-1)
                }, 1000)
              } else {
                this.Global.request_failure(res.Message)
              }
            })
            .catch((err) => {
              this.$message({
                type: 'error',
                message: err.message,
              })
            })
        } else {
          this.locateToErr();
          this.$message({
            type: 'error',
            message: '请完成相关信息后再进行保存',
          })
          return false
        }
      })
    },
    // 滚动条定位到第一个校验失败的div的位置
    locateToErr() {
      setTimeout(() => {
        const errorDiv = document.getElementsByClassName('is-error');
        errorDiv[0].scrollIntoView();
      }, 0)
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
    },
    GetNodeByDeptID(ID, NodeList) {
      let obj = null
      for (let i = 0; i < NodeList.length; i++) {
        if (NodeList[i].DeptID == ID) {
          obj = NodeList[i]
          break
        } else if (
          NodeList[i].fuzi && NodeList[i].children.length > 0 && NodeList[i].children[0].DeptID != '-1'
        ) {
          obj = this.GetNodeByDeptID(ID, NodeList[i].children);
          if (obj != null) break
        }
      }
      return obj
    },
    bumen(dt) {
      let obj = this.data[0]
      for (let i = 0; i < this.data.length; i++) {
        if (this.data[i].DeptID == dt[dt.length - 1]) {
          obj = this.data[i];
        } else if (this.data[i].fuzi && this.data[i].children.length > 0 && this.data[i].children[0].DeptID != '-1') {
          obj = this.GetNodeByDeptID(dt[dt.length - 1], this.data[i].children);
        }
      }
      
      let _this = this;
      if (obj.fuzi && obj.children.length > 0 && obj.children[0].DeptID == '-1') {
        obj.children = [{ label: this.$t('original.languages22') }]
        this.$Http_Post('/DepartMent/GetDeprtMentByNode', { DeptID: dt[dt.length - 1], content: '' }).then((res) => {
          if (res.Code == 200 || res.Code == 0 && res.Data) {
            obj.children = res.Data;
          }
        })
      } else {

      }
    },
  },

  mounted() {
    this.$Http_Post('User/GetDictionaryList', { DicTypCode: 1 }).then((res) => {
      if (res.Code == 200 || res.Code == 0) {
        this.gradedata = res.Data
      }
    })

    this.$Http_Post('/DepartMent/GetDeprtMentByNode', { DeptID: '', content: '' }).then((res) => {
      if (res.Code == 200 || res.Code == 0 && res.Data) {
        this.data = res.Data;
        this.data2 = res.Data;
        this.data3 = res.Data;
      }
    })

    this.$Http_Post('User/GetDictionaryList', { DicTypCode: 24 }).then((res) => {
      if (res.Code == 0) {
        this.value24 = res.Data
      }
    })

    this.$Http_Post('User/GetDictionaryList', { DicTypCode: 22 }).then((res) => {
      if (res.Code == 0) {
        this.value22 = res.Data
      }
    })

    this.$Http_Post('User/GetDictionaryList', { DicTypCode: 6 }).then((res) => {
      if (res.Code == 0) {
        this.value6 = res.Data
      }
    })

    this.$Http_Post('User/GetDictionaryList', { DicTypCode: 13 }).then((res) => {
      if (res.Code == 0) {
        this.value7 = res.Data
      }
    })
    
    .catch((err) => {
      this.$message({
        type: 'error',
        message: err.message,
      })
    })

    this.$Http_Post('User/GetUserType').then((res) => {
      if (res.Code == 200 || res.Code == 0) {
        this.opt = res.Data
      }
    })

    .catch((err) => {
      this.$message({
        type: 'error',
        message: err.message,
      })
    })
  },
}
</script>
<style>
.Useraddsingle .el-form-item {
  margin-bottom: 0px;
  width: 400px;
}

.Useraddsingle .el-form-item__content {
  margin-bottom: 20px;
}

.Useraddsingle>h2 {
  font-size: 16px;
}

.Useraddsingle .basic {
  width: 320px;
  margin-left: -20px;
}

.Useraddsingle .tit span {
  width: 3px;
  height: 20px;
  background-color: rgba(0, 136, 255, 1);
  display: inline-block;
  position: absolute;
  left: 0px;
  top: 0px;
}

.Useraddsingle .tit p {
  position: absolute;
  left: 10px;
  top: 0px;
}

.Useraddsingle .tit {
  position: relative;
  margin-top: 16px;
  height: 30px;
  margin-left: 20px;
}

.Useraddsingle .el-textarea textarea {
  height: 80px;
}

.Useraddsingle .el-form {
  margin-left: 20px;
  width: 900px;
}

.Useraddsingle .el-date-editor.el-input,
.Useraddsingle .el-date-editor.el-input__inner {
  width: 100%;
}

.Useraddsingle .el-cascader {
  width: 100%;
}

.Useraddsingle .el-select {
  width: 100%;
}

.Useraddsingle .el-textarea .el-input__count {
  height: 20px;
  bottom: 12px;
}
</style>
